import { ToolCard } from "@/components/atoms/modernise-with-ai/ToolCard";
import { modernizationTools } from "@/data/modernizationTools";

interface ToolsGridProps {
  selectedCategory: string;
  selectedTools: any[];
  onToolToggle: (tools: any[]) => void;
}

export const ToolsGrid: React.FC<ToolsGridProps> = ({
  selectedCategory,
  selectedTools,
  onToolToggle,
}) => {
  const filtered =
    selectedCategory === "All"
      ? modernizationTools
      : modernizationTools.filter((tool) => tool.category === selectedCategory);

  const toggleTool = (tool: any) => {
    const exists = selectedTools.find((t) => t.id === tool.id);
    if (exists) {
      onToolToggle(selectedTools.filter((t) => t.id !== tool.id));
    } else {
      onToolToggle([...selectedTools, tool]);
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {filtered.map((tool) => (
        <ToolCard
          key={tool.id}
          {...tool}
          isSelected={selectedTools.some((t) => t.id === tool.id)}
          onClick={() => toggleTool(tool)}
        />
      ))}
    </div>
  );
};
